// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__A9Dth","icon":"Badge_icon__DmDSW","text":"Badge_text__CxjQN"};